import {QueryClient, useQuery, useQueryClient} from '@tanstack/react-query';
import IWBrokerClient, {ConnectionState} from '../client/IWBrokerClient';
import {queryClient as defaultQueryClient} from './queryClient';

export const gatewayConnectionStateQueryKey = ['gatewayConnectionState'] as const;

const installedGatewayConnectionStateListeners = new WeakSet<QueryClient>();

export function installGatewayConnectionStateQueryListener(queryClient: QueryClient = defaultQueryClient) {
    if (installedGatewayConnectionStateListeners.has(queryClient)) {
        return;
    }

    queryClient.setQueryData(gatewayConnectionStateQueryKey, IWBrokerClient.connectionState$.getValue());

    IWBrokerClient.connectionState$.subscribe(connectionState => {
        queryClient.setQueryData(gatewayConnectionStateQueryKey, connectionState);
    });

    installedGatewayConnectionStateListeners.add(queryClient);
}

export function useGatewayConnectionStateQuery() {
    const queryClient = useQueryClient();
    const query = useQuery({
        queryKey: gatewayConnectionStateQueryKey,
        queryFn: async (): Promise<ConnectionState> => {
            return queryClient.getQueryData<ConnectionState>(gatewayConnectionStateQueryKey)
                ?? IWBrokerClient.connectionState$.getValue();
        },
        staleTime: Infinity,
        gcTime: Infinity,
        networkMode: 'always',
        retry: false
    });

    const connectionState = query.data ?? ConnectionState.Connecting;

    return {
        ...query,
        connectionState,
        isConnecting: connectionState === ConnectionState.Connecting
            || connectionState === ConnectionState.Reconnecting
    };
}
